// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3QFplOsxp4KeXJZCSc_jRB"};